var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('bread-crumb'),_c('el-card',{staticClass:"stationPlanview"},[_c('poster-editor',{staticClass:"content-main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }